import { List, Loader, Text, UnstyledButton } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { faqRecommendTranslation, faqRecommendTranslationParams } from '@mygpt/app/chat/services';
import { RecommendList } from '@mygpt/types';
import { FetchQuestionOptions } from '@mygpt/app/chat/hooks';

interface Props {
  aiId: string;
  list: RecommendList[];
  onClick: (value: string, options?: FetchQuestionOptions) => void;
}

const RecommendList: React.FC<Props> = ({ aiId, list, onClick }) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [recommendList, setRecommendList] = useState<RecommendList[]>([]);
  const [error, setError] = useState(false);

  const getRecommendListTranslate = () => {
    const params: faqRecommendTranslationParams = {
      ai_id: aiId,
      recommend_list: list,
    };
    faqRecommendTranslation(params)
      .then((res) => {
        const data: RecommendList[] = res.data;
        setRecommendList(data);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (list.length) getRecommendListTranslate();
  }, []);

  return (
    <List listStyleType="disc">
      {loading && <Loader variant="dots" color="gray.5" size={'sm'} mt={15} />}

      {error && (
        <Text size={'sm'} c={'red.5'} mt={15}>
          {t('errors.common')}
        </Text>
      )}

      {recommendList.map((recommend) => (
        <List.Item key={recommend.id} className="text-gray-500 hover:text-violet-700">
          <UnstyledButton
            className="text-sm text-gray-500 hover:text-violet-700 hover:underline focus:outline-none"
            onClick={() => {
              onClick(recommend.name, { faqID: recommend.id });
            }}
          >
            {recommend.name}
          </UnstyledButton>
        </List.Item>
      ))}
    </List>
  );
};

export default RecommendList;
